<template>
  <base-section
  id="venue"
  >
    <v-container>
    <base-section-heading
    title="Welcome to San Andrés Island!"
    color="secondary"
    align="left"
    :toColor="true"
    >

LATS'25 will be held in <strong>San Andrés Island</strong>, in Colombia. <br /> <br />

San Andrés Island is a beautiful Caribbean Island and a part of Colombia. San Andrés is located in the Caribbean Sea, and it is part of an archipelago that also includes Providencia and Santa Catalina islands. The island boasts pristine white sandy beaches, crystal-clear turquoise waters, and vibrant coral reefs. The marine biodiversity around the island is exceptional, making it a haven for snorkelers and divers. The culture of San Andrés is a unique blend of Colombian, Afro-Caribbean, and English influences, producing very particular music, cuisine, and island ‘s traditions San Andrés Island offers a perfect blend of natural beauty, cultural richness, and recreational opportunities, making it a sought-after destination for travellers seeking a Caribbean getaway with a Colombian twist.

    </base-section-heading>
    <!---
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.src"
        contain
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        />
      </v-carousel-item>
    </v-carousel>
    <br><br><br><br>
        <base-section-heading
    title="Hotel Registration"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>[DEADLINE] <span style="color: red;">New deadline</span> </strong> for advance registration and hotel booking is <strong>February 6th, 2024</strong>.<br>
    LATS2024 will be held in the <strong><strong><a href="https://www.hoteljatiuca.com.br/">Jatiúca Hotel & Resort</a></strong></strong>. If you want to reserve a room in the hotel please fill out the following form and send it to <strong><strong><a href="mailto:leticia@poehls.com">leticia@poehls.com</a></strong></strong>.
    <br /> <br />
<v-btn
  href="LATS2024_Registration-form_LATSHotel-Final_09022024.docx"
  target="_blank"
  rounded
  color="secondary"
  dark
  download
  style="padding: 15px"
>
  <v-icon
    left
    dark
  >
    mdi-download
  </v-icon>
  Download the LATS Hotel form
</v-btn>
<br />
    </base-section-heading>
    There is also an alternative option at <strong><a href="https://www.slavierohoteis.com.br/hoteis/jatiuca-suites-resorts-by-slaviero-hoteis">Jatiúca Suites Resort by Slaviero Hotel</a></strong>.
    If you want to reserve to this alternative hotel please fill out the following form and send it to <strong><strong><a href="mailto:leticia@poehls.com">leticia@poehls.com</a></strong></strong>.
    <br><br>
    <v-btn
  href="LATS2024_Registration-form_AlternativeHOTEL-Final_25012024.docx"
  target="_blank"
  rounded
  color="secondary"
  dark
  download
  style="padding: 15px"
>
  <v-icon
    left
    dark
  >
    mdi-download
  </v-icon>
  Download the Alternative Hotel form
</v-btn>
<br />
--->
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'WelcomeMaceio',

    data: () => ({
      slides: [
        {
          src: require('@/images/venue/maceio04.jpg'),
        },
        {
          src: require('@/images/venue/maceio03.jpg'),
        },
        {
          src: require('@/images/venue/maceio02.jpg'),
        },
        {
          src: require('@/images/venue/maceio01.jpg'),
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
